import { compose, withProps, onlyUpdateForKeys, setDisplayName } from 'recompose';
import { withRouter } from 'react-router-dom';

import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { withClassname } from '@components/hoc/withClassname';

import { ActionBar } from '@modules/protocols/ProtocolsGridButtons';

import { ProtocolsForm } from '@modules/protocols/ProtocolsForm';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';

export const protocolsUrl = '/metropolis/api/wa/protocols';
export const protocolsLabel = 'Skladové doklady';
export const protocolsPath = '/warehouses/protocols';
export const protocolsGridName = 'ProtocolsGrid';
export const ProtocolsGrid = compose(
  withRouter,
  setDisplayName('ProtocolsGrid'),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: protocolsLabel }]),
  withColumns(Agenda.PROTOCOLS),
  withProps(({ history, columns }) => ({
    name: protocolsGridName,
    url: protocolsUrl,
    Form: ProtocolsForm,
    dialog: false,
    gridProps: {
      columns,
      sort: 'number',
      defaultSort: 'number',
      filterRow: true,
      history,
      ActionBar,
      showCheckboxes: true,
      deleting: true,
      filtering: true,
      locale: 'cz',
      adding: false,
      pageSize: 50,
      version: 2
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/protocols/ProtocolsGrid.tsx